<template>
<div v-on-clickaway="close" class="wph-print-colors-dropdown wph-dropdown multiselect" :class="{ 'multiselect--active': show }">
  <div @click="toggle" class="multiselect__select"></div>
  <div @click="toggle" ref="dropdown-trigger" class="multiselect__tags">{{ selectedColorsNumber }}</div>
  <div v-show="show" ref="dropdown-list" class="multiselect__content-wrapper">
    <ul class="multiselect__content">
      <li class="multiselect__element"><span class="multiselect__option"><span><app-checkbox :value="needsSubstrate" disabled>Подложка</app-checkbox></span></span></li>
      <li class="multiselect__element" v-for="(color, index) in location.colors" :key="color.name"><span
        class="multiselect__option"
      ><span><app-checkbox
        :value="color.selected"
        @change="onColorSelectionChange($event, index)"
        :disabled="!color.selected && maxSelectedColorsNumberReached"
      >{{ color.name }}
      </app-checkbox></span></span></li>
    </ul>
  </div>
  <div
    class="wph-text-xs"
    :class="maxSelectedColorsNumberReached ? 'wph-text-red' : 'wph-text-gray-500'"
  >макс. <strong>{{ maxSelectedColorsNumber }}</strong></div>
</div>
</template>

<script>
import popper from 'popper.js'
import { mixin as clickaway } from 'vue-clickaway'
import AppCheckbox from './Checkbox'

export default {
  name: "PrintColorsDropdown",
  components: {
    AppCheckbox,
  },
  mixins: [clickaway],
  props: {
    location: { type: Object, required: true },
    needsSubstrate: { type: Boolean, required: true },
    maxSelectedColorsNumber: { type: Number, required: true },
    updateProduct: Function,
  },
  mounted() {
    this.popper = new popper(this.$refs['dropdown-trigger'], this.$refs['dropdown-list'], {
      placement: 'bottom-start',
    })
  },
  beforeDestroy() {
    this.popper.destroy()
  },
  data() {
    return {
      show: false,
      popper: null,
    }
  },
  computed: {
    selectedColors() {
      return this.location.colors.filter(color => color.selected === true)
    },
    selectedColorsNumber() {
      const substrate = this.needsSubstrate ? 1 : 0
      return this.selectedColors.length + substrate
    },
    maxSelectedColorsNumberReached() {
      return this.selectedColorsNumber >= this.maxSelectedColorsNumber
    },
  },
  methods: {
    toggle() {
      this.show = !this.show
    },
    close() {
      this.show = false
    },
    onColorSelectionChange(selected, index) {
      this.$emit('color-selection-change', { index, selected })
    },
  },
}
</script>

<style scoped>
  .multiselect__content-wrapper {
    min-width: 300px;
  }
</style>